import axios from "axios";
import main from "../main"

const client = axios.create({ baseURL: process.env.VUE_APP_API_URL });


async function authentication(request) {
    await main.$store.state.authentication.keycloak.updateToken(5)

    request.headers['Authorization'] = `Bearer ${main.$store.state.authentication.keycloak.token}`;

    return request;
}

function agency(request) {
    console.log(request.params)
    if (!request.params) request.params = {}

    request.params.agency = main.$route.params.agency;

    return request;
}


client.interceptors.request.use(agency);
client.interceptors.request.use(authentication);

/*client.interceptors.response.use((response) => {
    return response;
}, (error) => {
    if (error.response.status >= 500) {
        //TODO sentry
        main.$toasted.global.error()
    }
})*/

export default {
    get(url, params = {}) {
        return client.get(url, { params });
    },

    post(url, data = {}, options = {}) {
        return client.post(url, data, options);
    },

    patch(url, data = {}, options = {}) {
        return client.patch(url, data, options);
    },

    delete(url, data = {}, options = {}) {
        return client.delete(url, data, options);
    }
};
